import { FC } from "react";
import styles from "./TopBar.module.scss";
import LanguageButtons from "./LanguageButtons";
import Logo from "@/components/logo";

const TopBar: FC = () => {
  return (
    <div className={styles.topBar}>
      <Logo />
      <div className="row">
        <LanguageButtons />
      </div>
    </div>
  );
};

export default TopBar;
